<app-alert-banner #alertBanner *ngIf="isBannerEnabled$ | async" (closeBanner)="closeBanner()"></app-alert-banner>
<router-outlet></router-outlet>
